import { IFeaturedPosts } from "../interfaces";
import { posts } from "@/app/data/blogPostData";

export const getPostBySlug = (slug: string): IFeaturedPosts => {
  return posts.find((post) => post.slug === slug) as IFeaturedPosts;
};
